// src/components/EmailVerification.jsx
import { useState } from "react";
import LoadingSvg from "../Loading";
import { useAuth } from "../../auth/AuthContext"; // 👈 ajusta ruta

export default function EmailVerification({ email, onVerify }) {
  const { login } = useAuth();

  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    setError("");

    if (code.length !== 6) {
      setError("Code must be 6 digits.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/verify`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include", // ✅ cookies HttpOnly
          body: JSON.stringify({ email, code }),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.error || "Incorrect code");
      }

      if (!data?.verified) {
        throw new Error("Invalid verification");
      }

      // callback opcional al padre
      onVerify?.();
    } catch (err) {
      console.error(err);
      setError(err.message || "Error verifying. Try again later.");
    } finally { 
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <LoadingSvg size={400} pulse />
        </div>
      )}

      <div className="w-full min-h-screen bg-[#EDF0F2] flex justify-center items-center p-8">
        <div className="bg-white rounded-2xl shadow-md w-full max-w-xl p-10 flex flex-col gap-6 text-center">
          <h2 className="text-3xl font-semibold">Verify your email</h2>

          <p className="text-gray-600">
            Enter the 6-digit code sent to
            <span className="font-semibold text-green-600"> {email}</span>
          </p>

          <input
            type="text"
            maxLength={6}
            value={code}
            onChange={(e) => {
              const onlyNumbers = e.target.value.replace(/\D/g, "");
              setCode(onlyNumbers);
            }}
            className="w-full text-center text-2xl tracking-[0.5em] py-3 border-b-2 border-gray-400 focus:border-green-600 outline-none"
          />

          <button
            onClick={handleVerify}
            disabled={loading}
            className={`w-full bg-black text-white py-3 rounded-xl transition 
            ${loading ? "opacity-70 cursor-not-allowed" : "hover:bg-gray-800"}`}
          >
            {loading ? "Verifying..." : "Verify"}
          </button>

          {error && <p className="text-red-600 mt-2">{error}</p>}
        </div>
      </div>
    </>
  );
}
